/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqItem } from '../../models/faq-item';

export interface GetFaq$Params {
  id: string;
  'X-Region'?: any;
}

export function getFaq(http: HttpClient, rootUrl: string, params: GetFaq$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqItem>> {
  const rb = new RequestBuilder(rootUrl, getFaq.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Region', params['X-Region'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqItem>;
    })
  );
}

getFaq.PATH = '/faq/{id}';
